/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_7_Links_0_LabelInputs */

const en_gc_search_guides_gridcraft_excel_compatibility_sections_7_links_0_label = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_7_Links_0_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Review the browser saving steps`)
};

const zh_gc_search_guides_gridcraft_excel_compatibility_sections_7_links_0_label = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_7_Links_0_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`复习浏览器保存步骤`)
};

/**
* | output |
* | --- |
* | "Review the browser saving steps" |
*
* @param {Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_7_Links_0_LabelInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_excel_compatibility_sections_7_links_0_label = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_7_Links_0_LabelInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_7_Links_0_LabelInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_excel_compatibility_sections_7_links_0_label(inputs)
	return zh_gc_search_guides_gridcraft_excel_compatibility_sections_7_links_0_label(inputs)
});
export { gc_search_guides_gridcraft_excel_compatibility_sections_7_links_0_label as "gc.search_guides.gridcraft_excel_compatibility.sections.7.links.0.label" }